<template>
  <div>
    <div class="d-flex flex-row">
      <v-checkbox
        v-model="tipos"
        :readonly="isAllowed"
        :value="1"
        label="Produto"
        class="mr-4"
      />

      <v-checkbox
        v-model="tipos"
        :readonly="isAllowed"
        :value="2"
        label="Serviço externo"
        class="mr-4"
      />

      <v-checkbox
        v-model="tipos"
        :readonly="isAllowed"
        :value="3"
        label="Serviço interno"
      />
    </div>
    <v-row align="center">
      <v-col col="6">
        <v-text-field
          label="Produto / Serviço *"
          v-model="descricao"
          v-uppercase
          :counter="200"
          :readonly="isAllowed"
          :rules="[(v) => !!v || 'A Descrição é obrigatória']"
          required
        ></v-text-field>
      </v-col>
      <v-col col="6">
        <v-select
          v-model="unidadeMedidaSelected"
          :items="unidadesMedida"
          label="Unidade de Medida *"
          item-text="descricao"
          item-value="id"
          persistent-hint
          return-object
          :readonly="isAllowed"
          :rules="[(v) => !!v || 'A Unidade Medida é obrigatória']"
          required
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col col="6">
        <v-text-field
          label="Código"
          v-model="codigo"
          :counter="200"
          :readonly="isAllowed"
        ></v-text-field>
      </v-col>
      <v-col col="6">
        <v-autocomplete
          v-model="grupoSelected"
          :items="grupos"
          label="Grupo *"
          item-text="descricao"
          item-value="id"
          persistent-hint
          return-object
          :readonly="isAllowed"
          :rules="[(v) => !!v || 'O Grupo é obrigatório']"
          required
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col col="6">
        <v-autocomplete
          v-model="subGrupoSelected"
          :items="filteredSubgrupo"
          label="Subgrupo *"
          item-text="descricao"
          item-value="id"
          persistent-hint
          return-object
          :readonly="isAllowed"
          :disabled="!grupoSelected"
          :rules="[(v) => !!v || 'O Subgrupo é obrigatório']"
          required
        >
        </v-autocomplete>
      </v-col>
      <v-col col="6">
        <v-autocomplete
          v-model="marcaSelected"
          :items="marcas"
          label="Marca *"
          item-text="descricao"
          item-value="id"
          persistent-hint
          return-object
          :readonly="isAllowed"
          :rules="[(v) => !!v || 'A  Marca é obrigatória']"
          required
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12" sm="6">
        <v-text-field
          label="Último Preço"
          :counter="200"
          disabled
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="5">
        <v-autocomplete
          v-model="conversaoSelected"
          :items="produtos"
          label="Conversões"
          item-text="descricao"
          item-value="id"
          persistent-hint
          return-object
          :readonly="isAllowed"
          :disabled="!possuiConversao"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="1">
        <v-tooltip bottomn v-if="!isAllowed">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="info"
              fab
              small
              v-bind="attrs"
              v-on="on"
              @click="addCoversao()"
              class="white--text"
              :disabled="!possuiConversao"
            >
              <v-icon> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span v-if="isAllowed">Adicionar conversão</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col col="6">
        <v-autocomplete
          v-model="departamentoSelected"
          :items="departamentos"
          label="Departamento"
          item-text="descricao"
          item-value="id"
          persistent-hint
          return-object
          single-line
          :rules="[(v) => !!v || 'O Departamento é obrigatório']"
          required
          :readonly="isAllowed"
        >
        </v-autocomplete>
      </v-col>
      <v-col col="6"> </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "formularioProduto",
  data: () => ({
    tipo: "1",
    descricao: null,
    codigo: null,
    grupoSelected: null,
    subGrupoSelected: null,
    marcaSelected: null,
    unidadeMedidaSelected: null,
    conversaoSelected: null,
    departamentoSelected: null,
    tipos: [1],
    loadingSubGrupos: false,
  }),
  props: {
    grupos: Array,
    subGrupos: Array,
    marcas: Array,
    unidadesMedida: Array,
    departamentos: Array,
    produtos: Array,
    conversoes: Array,
    possuiConversao: Boolean,
    isAllowed: Boolean,
  },

  computed: {
    filteredSubgrupo() {
      return this.subGrupos.filter((sg) => {
        return this.grupoSelected ? (sg.idGrupo === this.grupoSelected.id && sg.ativo === true) : null;
      });
    },
  },
  methods: {
    fillForm(produto) {
      //this.tipo = produto.tipo.toString();
      this.tipos = produto.tipos;
      this.descricao = produto.descricao;
      this.codigo = produto.codigo;
      this.grupoSelected = this.findGrupo(produto.idGrupo);
      this.subGrupoSelected = this.findSubGrupo(produto.idSubGrupo);
      this.marcaSelected = this.findMarca(produto.idMarca);
      this.unidadeMedidaSelected = this.findUnidadeMedida(
        produto.idUnidadeMedida
      );
      this.departamentoSelected = this.findDepartamento(produto.idDepartamento);
    },

    findGrupo(grupoId) {
      return this.grupos.find((g) => g.id === grupoId);
    },
    findSubGrupo(subGrupoId) {
      return this.subGrupos.find((sg) => sg.id === subGrupoId);
    },
    findMarca(marcaId) {
      return this.marcas.find((m) => m.id === marcaId);
    },
    findUnidadeMedida(unidadeId) {
      return this.unidadesMedida.find((um) => um.id === unidadeId);
    },
    findDepartamento(departamentoId) {
      return this.departamentos.find((d) => d.id === departamentoId);
    },
    addCoversao: function (e) {
      if (this.conversaoSelected == null) {
        e.preventDefault();
      }
      this.conversoes.push(this.conversaoSelected);
      this.conversaoSelected = null;

      /*var filtered = this.produtos.filter(function (e) {
        return this.indexOf(e) < 0;
      }, this.conversoes);
      alert(JSON.stringify(filtered));*/
    },
  },
};
</script>
